module.exports = __webpack_public_path__ + "img/logo.e66331f0.png";